<div
  class="skeleton-container"
  [ngClass]="{
    horizontal: (appearance === 'rounded' || appearance === 'chip') && count > 1
  }"
>
  <div
    *ngFor="let item of [].constructor(count)"
    class="skeleton"
    [ngClass]="{
      rounded: appearance === 'rounded',
      chip: appearance === 'chip'
    }"
    [ngStyle]="{ width: width, height: height, 'border-radius': borderRadius }"
    [style.marginBottom.px]="appearance !== 'default' ? 5 : marginBottom ? marginBottom : 0"
  ></div>
</div>
